var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgBlogYoutube = function SvgSvgBlogYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.325 4.363a2.41 2.41 0 0 0-1.698-1.709c-1.497-.404-7.502-.404-7.502-.404s-6.005 0-7.502.404A2.41 2.41 0 0 0 .925 4.363C.524 5.87.524 9.014.524 9.014s0 3.143.4 4.651a2.373 2.373 0 0 0 1.699 1.68c1.497.405 7.502.405 7.502.405s6.005 0 7.502-.404a2.38 2.38 0 0 0 1.698-1.68c.401-1.509.401-4.652.401-4.652s0-3.143-.4-4.651ZM8.163 11.869v-5.71l5.017 2.855-5.017 2.855Z",
    fill: "currentColor"
  })));
};
export default SvgSvgBlogYoutube;